export const textColor = '#333333';
export const textColorSecondary = '#848484';
export const surfaceBorder = '#c8c8c8';
export const digitsMapping = [
    '',
    'Thousands',
    'Millions',
    'Billions',
    'Trillions'
];
